(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
function toggleBackText(select) {
  const backDiv = document.getElementById('backPrintText');
  if (backDiv) {
    backDiv.style.display = select.value.includes("Yes") ? 'block' : 'none';
  }
}

function toggleArmText(select) {
  const armDiv = document.getElementById('armPrintText');
  if (armDiv) {
    armDiv.style.display = select.value.includes("Yes") ? 'block' : 'none';
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const backPrintSelect = document.getElementById("backPrintSelect");
  const armPrintSelect = document.getElementById("armPrintSelect");

  if (backPrintSelect) {
    toggleBackText(backPrintSelect);
    backPrintSelect.addEventListener("change", function () {
      toggleBackText(this);
    });
  }

  if (armPrintSelect) {
    toggleArmText(armPrintSelect);
    armPrintSelect.addEventListener("change", function () {
      toggleArmText(this);
    });
  }

  // Handle add-on product logic
  document.querySelector('form[action^="/cart/add"]')?.addEventListener("submit", function (e) {
    const form = e.target;
    const addOnItems = [];

    // Back Print
    const backPrintOption = document.querySelector('#backPrintSelect option:checked');
    if (backPrintOption?.value === "Yes") {
      const variantId = backPrintOption.dataset.variantId;
      if (variantId) {
        addOnItems.push({ id: variantId, quantity: 1 });
      }
    }

    // Arm Print
    const armPrintOption = document.querySelector('#armPrintSelect option:checked');
    if (armPrintOption?.value === "Yes") {
      const variantId = armPrintOption.dataset.variantId;
      if (variantId) {
        addOnItems.push({ id: variantId, quantity: 1 });
      }
    }

    // Custom Name (text input)
    const customNameInput = document.querySelector('input[name="properties[Custom Name]"]');
    if (customNameInput && customNameInput.value.trim() !== "") {
      addOnItems.push({ id: "53976681578787", quantity: 1 }); // ✅ Update this ID if needed
    }

    // Design Fee (always included — optional logic here)
    const designFeeEnabled = true; // You can add logic to toggle this
    if (designFeeEnabled) {
      addOnItems.push({ id: "48991656640803", quantity: 1 }); // ✅ Update this ID if needed
    }

    // Optional: Mockup Preview
    const mockupPreview = document.querySelector('select[name="properties[Mockup Preview]"]');
    if (mockupPreview && mockupPreview.value === "Yes") {
      addOnItems.push({ id: "53976683184419", quantity: 1 }); // ✅ Update this ID if needed
    }

    // Prevent default submission if add-ons exist
    if (addOnItems.length > 0) {
      e.preventDefault();

      // Submit main product first
      const formData = new FormData(form);
      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then(() => {
          // Then submit each add-on
          return fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ items: addOnItems }),
          });
        })
        .then(() => {
          window.location.href = "/cart";
        })
        .catch((err) => {
          console.error("❌ Add-on add-to-cart error:", err);
          alert("There was an error adding your items to the cart.");
        });
    }
  });

  // Helpers
  function toggleBackText(select) {
    const backDiv = document.getElementById("backPrintText");
    if (backDiv) {
      backDiv.style.display = select.value === "Yes" ? "block" : "none";
    }
  }

  function toggleArmText(select) {
    const armDiv = document.getElementById("armPrintText");
    if (armDiv) {
      armDiv.style.display = select.value === "Yes" ? "block" : "none";
    }
  }
});


  } catch(e) { console.error(e); }
})();
})();
